import { apiClient } from "@api/apiClient";

import { adaptRegulatoryListData } from "./adaptRegulatoryList.data";

import type {
  RegulatoryFilteringData,
  PostRegulatoryListFilterApiResponse,
} from "@interface/regulatoryList.interface";

const API_ENDPOINT = {
  regulatoryList: "/edb/internal/regulatory-label/search",
  checkPressStatus: "/des/draft-article/status",
};

export const regulatoryListApis = {
  post: async (filteringData: RegulatoryFilteringData) => {
    const { data } = await apiClient.post<PostRegulatoryListFilterApiResponse>(
      API_ENDPOINT.regulatoryList,
      filteringData,
    );

    return adaptRegulatoryListData(data);
  },
  checkPressStatus: async (draftArticleId: string) => {
    const { data } = await apiClient.get(
      `${API_ENDPOINT.checkPressStatus}/${draftArticleId}`,
    );
    return data;
  },
};
